import React, { useEffect } from 'react';
import { CatalogList } from '../CatalogList';
import URL from '@/creditflowresearch/Router/urlConstants';
import { useCatalogSponsorsContext } from '@/creditflowresearch/application/Catalog/Sponsors/SponsorsCatalogContext';

const Sponsors = () => {
  const { sponsorsList, isFetching, reset } = useCatalogSponsorsContext();

  useEffect(() => () => reset(), []);

  return (
    <CatalogList
      isFetching={ isFetching }
      data={ sponsorsList }
      catalogUrl={ URL.SPONSOR }
      bodyHeight={ 740 }
    />
  );
};

export default Sponsors;
